type RoleNamesType = {
  [key: number]: string;
};

const permissions: RoleNamesType = {
  5: "Administrator",
  4: "Владелец",
  3: "Менеджер",
  2: "Пользователь",
  1: "Гость",
};

export default permissions;
